import { attributeSlot, ProductBookingSlot } from '../types/productBookingSlot';
import { Product, SellingMode } from '@src/core/buyerApiClient/api';
import { type ProductStepType } from '@src/stores/product';
import type { TariffGroupAttributeType } from '../types/attribute';

export const orderedEmbedSlots = (
  product: Product,
  steps: ProductStepType[],
  includeLanguage = false,
  attributeTypes: TariffGroupAttributeType[] = [],
): ProductBookingSlot[] => {
  const slots: ProductBookingSlot[] = [];

  if (steps.includes('calendar')) {
    slots.push('calendar');
  }

  if (includeLanguage) {
    slots.push('language');
  }

  for (const type of attributeTypes) {
    slots.push(attributeSlot(type));
  }

  slots.push('tariff');

  if (product && product.sellingMode === SellingMode.WithDateAndTime) {
    slots.push('time');
  }

  if (steps.includes('seat_map')) {
    slots.push('seat_map');
  }

  if (steps.includes('additional')) {
    slots.push('additionals');
  }

  return slots;
};
